import React from "react";
import {useNavigate} from 'react-router-dom';
import {isNullOrEmptyArray} from "../../../../utils/general.js";
import PartnershipCategoryValue from "../../PartnershipCategoryValue";
import ProgramProgress from "./ProgramProgress";

import './ProgramCategoryBox.scss';

const ProgramCategoryBox = props => {
	const {programs, children} = props;
	const navigate = useNavigate();

	const renderProgram = (program, i) => {
		return (
			<div key={i}>
				<div className="widgets-partnership-separator" />
				<div className="widgets-partnership-box-program-name">
					<span className="widgets-partnership-box-program-link" onClick={() => navigate(`/program/${program.Id}`)}>{program.Name}</span>
					<ProgramProgress value={program.Progress__c} />
				</div>
			</div>
		)
	};

	return (
		<div className="widgets-partnership-box">
			<PartnershipCategoryValue programs={programs} item={children} />
			{ !isNullOrEmptyArray(programs) ? programs.map(renderProgram) : <div className="widgets-partnership-separator" />}
		</div>
	)
};

export default ProgramCategoryBox;